import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import useTheme from '@mui/material/styles/useTheme';
import Typography from '@mui/material/Typography';
import { IconCloudOff } from '@tabler/icons';
import React, { useEffect, useState } from 'react';
import './styles.scss';

const OfflineIndicator = () => {
	const [isOffline, setIsOffline] = useState<boolean>(false);
	const theme = useTheme();

	useEffect(() => {
		window.addEventListener('offline', () => {
			setIsOffline(true);
		});
		window.addEventListener('online', () => {
			setIsOffline(false);
		});
	}, []);

	return (
		<Modal open={isOffline}>
			<div className='offline-card'>
				<Paper variant='outlined' sx={{ padding: 3, maxWidth: 500 }}>
					<Stack direction='row' alignItems='start'>
						<IconCloudOff size={42} color={theme.palette.primary.main} />
						<Stack marginLeft={3} justifyContent='start' alignItems='start'>
							<Typography variant='h3'>Offline</Typography>
							<Typography variant='caption' fontSize={14} sx={{ marginY: 1 }}>
								Your network is unavailable.
								<br /> Please check your data or wifi connection.
							</Typography>
							<Button onClick={() => window.location.reload()}>Refresh</Button>
						</Stack>
					</Stack>
				</Paper>
			</div>
		</Modal>
	);
};

export default OfflineIndicator;
